import React, { createContext, useReducer, ReactNode } from 'react';
import { appStateReducer } from './AppReducer';
import { Conversation } from '../api';
  
export interface AppState {
    currentChat: Conversation | null;
    showHeader: boolean;
    showUsageDisclaimer: boolean;
    consentGiven: boolean;
}

export type Action =
    | { type: 'UPDATE_CURRENT_CHAT', payload: Conversation | null }
    | { type: 'UPDATE_SHOW_HEADER', payload: boolean }
    | { type: 'UPDATE_SHOW_USAGE_DISCLAIMER', payload: boolean }
    | { type: 'UPDATE_CONSENT_GIVEN', payload: boolean }

const initialState: AppState = {
    currentChat: null,
    showHeader: false,
    showUsageDisclaimer: false,
    consentGiven: false
};

export const AppStateContext = createContext<{
    state: AppState;
    dispatch: React.Dispatch<Action>;
  } | undefined>(undefined);

type AppStateProviderProps = {
    children: ReactNode;
  };
  
  export const AppStateProvider: React.FC<AppStateProviderProps> = ({ children }) => {
    const [state, dispatch] = useReducer(appStateReducer, initialState);

    return (
      <AppStateContext.Provider value={{ state, dispatch }}>
        {children}
      </AppStateContext.Provider>
    );
  };


